const orgTypes = [
  { key: 'ACADEMIC INSTITUTION', text: 'ACADEMIC INSTITUTION', value: 'ACADEMIC INSTITUTION' },
  { key: 'AMBULANCE', text: 'AMBULANCE', value: 'AMBULANCE' },
  { key: 'ANALYTICAL LAB', text: 'ANALYTICAL LAB', value: 'ANALYTICAL LAB' },
  { key: 'ANIMAL SHELTER', text: 'ANIMAL SHELTER', value: 'ANIMAL SHELTER' },
  { key: 'ASC', text: 'ASC', value: 'ASC' },
  { key: 'CHAIN HOSPITAL', text: 'CHAIN HOSPITAL', value: 'CHAIN HOSPITAL' },
  { key: 'CHEMPACK', text: 'CHEMPACK', value: 'CHEMPACK' },
  { key: 'CLINIC', text: 'CLINIC', value: 'CLINIC' },
  { key: 'COMPOUNDER', text: 'COMPOUNDER', value: 'COMPOUNDER' },
  { key: 'DETOXIFICATION', text: 'DETOXIFICATION', value: 'DETOXIFICATION' },
  { key: 'DISTRIBUTOR', text: 'DISTRIBUTOR', value: 'DISTRIBUTOR' },
    { key: 'EXPORTER', text: 'EXPORTER', value: 'EXPORTER' },
    { key: 'FOUNDATION', text: 'FOUNDATION', value: 'FOUNDATION' },
  { key: 'GPO', text: 'GPO', value: 'GPO' },
  { key: 'GRP', text: 'GRP', value: 'GRP' },
  { key: 'HEALTH NETWORK', text: 'HEALTH NETWORK', value: 'HEALTH NETWORK' },
  { key: 'HOME HEALTH', text: 'HOME HEALTH', value: 'HOME HEALTH' },
  { key: 'HOSPICE', text: 'HOSPICE', value: 'HOSPICE' },
  { key: 'HOSPITAL', text: 'HOSPITAL', value: 'HOSPITAL' },
  { key: 'IMPORTER', text: 'IMPORTER', value: 'IMPORTER' },
  { key: 'KAISER', text: 'KAISER', value: 'KAISER' },
  { key: 'LONG TERM CARE', text: 'LONG TERM CARE', value: 'LONG TERM CARE' },
  { key: 'MAINTENANCE', text: 'MAINTENANCE', value: 'MAINTENANCE' },
  { key: 'MANUFACTURER', text: 'MANUFACTURER', value: 'MANUFACTURER' },
  { key: 'MCO', text: 'MCO', value: 'MCO' },
  { key: 'MEDICAL ASSOCIATION', text: 'MEDICAL ASSOCIATION', value: 'MEDICAL ASSOCIATION' },
  { key: 'NH', text: 'NH', value: 'NH' },
  { key: 'NURSING HOME', text: 'NURSING HOME', value: 'NURSING HOME' },
  { key: 'ONCOLOGY NETWORK', text: 'ONCOLOGY NETWORK', value: 'ONCOLOGY NETWORK' },
  { key: 'PATIENT GROUP', text: 'PATIENT GROUP', value: 'PATIENT GROUP' },
  { key: 'PHARMACY', text: 'PHARMACY', value: 'PHARMACY' },
  { key: 'RADIOLOGY CENTER', text: 'RADIOLOGY CENTER', value: 'RADIOLOGY CENTER' },
  { key: 'TEACHING INSTITUTION', text: 'TEACHING INSTITUTION', value: 'TEACHING INSTITUTION' },
  { key: 'WAREHOUSE', text: 'WAREHOUSE', value: 'WAREHOUSE' },
];

export default orgTypes;
